import ReactDOM from "react-dom";
import ProjectsListPage from "components/ProjectsList/ProjectsListPage";

class AhMaProjectsListPage extends ProjectsListPage {
  /**
   * Set page identifier classes
   * (To specifically target this page for styling/customizations)
   */
  componentDidMount() {
    // Set page identifier class to .component-container
    let mainComponent = ReactDOM.findDOMNode(this).parentNode;
    if (!mainComponent.classList.contains("projectsListPage")) {
      mainComponent.className += " projectsListPage";
    }

    // Add other page classes to body DOM
    let bodyDOM = document.body; // <body> tag
    if (!bodyDOM.classList.contains("page-loggedin")) {
      bodyDOM.className += " page-loggedin";
    }

    if (!bodyDOM.classList.contains("projectsListPageBody")) {
      bodyDOM.className += " projectsListPageBody";
    }
  }

  /**
   * Remove page identifier classes
   */
  componentWillUnmount() {
    // Remove page identifier class from .component-container
    let mainComponent = ReactDOM.findDOMNode(this).parentNode;
    if (mainComponent.classList.contains("projectsListPage")) {
      mainComponent.classList.remove("projectsListPage");
    }

    // Remove other page classes from body DOM
    let bodyDOM = document.body;
    if (bodyDOM.classList.contains("page-loggedin")) {
      bodyDOM.classList.remove("page-loggedin");
    }

    if (bodyDOM.classList.contains("projectsListPageBody")) {
      bodyDOM.classList.remove("projectsListPageBody");
    }
  }
}

export default AhMaProjectsListPage;
